// @flow
import React from "react";
import { connect } from "react-redux";
import { Translate } from "@quantum/i18n";
import SelectInput from "../../../comum/SelectInput";
import {
  getDeflatores,
  selecionarDeflator,
  getDeflatorSelecionado,
  type ActionCreator,
} from "../../../../state";

import { ID_OPCAO_DEFLATOR_NENHUM } from "../../../../model";
import type { Deflator } from "../../../../model";
import { partition, pipe, propEq, propOr, sort } from "ramda";

type Props = {
  listaDeflatores: Array<Deflator>,
  deflatorSelecionado: string,
  selecionarDeflator: ActionCreator,
};

function SelecaoDeflator({
  listaDeflatores,
  deflatorSelecionado,
  selecionarDeflator,
}: Props) {
  function onChange(deflator) {
    selecionarDeflator(deflator);
  }

  return (
    <div className="ConfiguracaoMedida__box">
      <label className="ConfiguracaoMedida__label">
        <Translate>ConfiguracaoIndicador.Deflator</Translate>
      </label>
      <SelectInput
        alwaysOpen={true}
        portal={false}
        options={listaDeflatores}
        value={deflatorSelecionado}
        onChange={onChange}
        size={1}
        multiple={false}
        campoDescricao="nome"
        campoId="codigo"
      />
    </div>
  );
}

export default connect(
  state => ({
    listaDeflatores: pipe(
      partition(propEq("codigo", ID_OPCAO_DEFLATOR_NENHUM)),
      ([deflatorNenhum, otherDeflatores]) => [
        ...deflatorNenhum,
        ...sort(
          (deflatorA, deflatorB) =>
            propOr("", "nome", deflatorA).localeCompare(
              propOr("", "nome", deflatorB)
            ),
          otherDeflatores
        ),
      ]
    )(getDeflatores(state)),
    deflatorSelecionado: getDeflatorSelecionado(state),
  }),
  { selecionarDeflator }
)(SelecaoDeflator);
